/**
 * AI.GEN lines=1-79
 * 权限管理类
 */
import { ClassBase, execFunction } from '@hpfe/common-base';
import md5 from 'md5';

import { context } from '@/context/index';
import { User } from '@/context/user';

interface Options {
  user?: User;
}

interface Events {
  setButtonPermissions: void;
}

export class Permission extends ClassBase<Options, Events> {
  private buttonPermissions: any = {};

  constructor() {
    super({});
  }

  init(options: { user: User }) {
    const user = options.user;

    user.emitter.on('logout', () => {
      this.setButtonPermissions({});
    });
  }

  setButtonPermissions(permissions: Record<string, string | string[]>) {
    this.buttonPermissions = permissions;
    this.emitter.emit('setButtonPermissions');
  }

  updateButtonPermissions(
    key: string,
    permissions: Record<string, string | string[]>,
  ) {
    this.buttonPermissions = {
      ...this.buttonPermissions,
      [key]: permissions,
    };
    this.emitter.emit('setButtonPermissions');
  }

  hasButtonPermission(
    moduleCode: string,
    pageCode: string,
    buttonCode: string,
  ) {
    let result = false;

    //IAM权限
    result = execFunction(() => {
      const buttonHash = md5(
        `${context.user.userInfo?.userToken}/${moduleCode}/${pageCode}/${buttonCode}`,
      );
      return (
        this.buttonPermissions[`${moduleCode}/${pageCode}/${buttonCode}`] ===
        buttonHash
      );
    });
    //erp权限
    if (!result) {
      result = execFunction(() => {
        const buttonHash = md5(
          `/${moduleCode}/${pageCode}/${buttonCode}`,
        ).toUpperCase();

        return (
          this.buttonPermissions[`${moduleCode}/${pageCode}`] || []
        ).includes(buttonHash);
      });
    }

    return result;
  }
}
